<script>
export default {
  props: ["progress"], // { 0..1 }
};
</script>

<template>
  <div class="fprogress-bg">
    <div
      class="fprogress-hover"
      v-bind:style="{ width: Math.min(100, Math.round(progress * 100)) + '%' }"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.fprogress-bg {
  height: 8px;
  background-color: rgba(24, 144, 211, 0.05);
  border-radius: 4px;

  .fprogress-hover {
    background-color: rgba(92, 186, 182, 1);
    height: 100%;
    border-radius: 4px;
  }
}

.dark-mode {
  .fprogress-bg {
    background-color: var(--black);

    .fprogress-hover {
      background-color: var(--primary);
    }
  }
}
</style>